import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Import translation resources
import enTranslations from './locales/en.json'
import enCompanyTranslations from './locales/en-company.json'
import enSchoolTranslations from './locales/en-school.json'

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
        'en-company': enCompanyTranslations,
        'en-school': enSchoolTranslations,
      },
    },
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language
    // debug: process.env['NODE_ENV'] === 'development',
    
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    
    // Namespace configuration
    defaultNS: 'translation',
    ns: ['translation', 'en-company', 'en-school'],
    
    // React i18next options
    react: {
      useSuspense: false, // Disable suspense for better error handling
    },
  })

export default i18n
